<template>
  <el-upload
    v-loading="loading"
    :action="action"
    :multiple="false"
    :limit="1"
    :headers="headers"
    :before-upload="onBefore"
    :on-change="submitUpload"
    :on-remove="handleRemove"
    :file-list="fileList"
    :on-error="onError"
    :on-success="onSuccess"
    ref="audio"
    @click.native="onAttach"
  >
    <el-button
      slot="trigger"
      size="small"
      type="primary"
      :disabled="!!fileList.length"
      >Выберите файл</el-button
    >
    <div v-if="!loading && uploadValue && !fileList.length">
      {{ value }}
      <el-button
        v-if="!fileList.length"
        type="danger"
        icon="el-icon-delete"
        circle
        @click="uploadValue = ''"
      />
    </div>
    <i v-if="error">{{ error }}</i>
  </el-upload>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";

export default {
  props: {
    value: {
      type: [File, Array, String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      fileList: [],
      error: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["mediaUrl"]),
    action() {
      const baseApi = process.env.VUE_APP_BASE_API
        ? process.env.VUE_APP_BASE_API
        : "";
      return `${baseApi}/hosting/files/?file_type=other`;
    },
    headers() {
      return {
        Authorization: `Bearer ${getToken()}`,
      };
    },
    uploadValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    audioUrlFull() {
      return `${this.mediaUrl}/${
        Array.isArray(this.uploadValue)
          ? this.uploadValue[0].response
          : this.uploadValue
      }`;
    },
  },
  watch: {
    // если форму сбросили, удаляем прикрепленные файлы
    value(newVal) {
      if (!newVal) {
        this.fileList = [];
      }
    },
  },
  methods: {
    submitUpload(file, fileList) {
      this.fileList = fileList;
      this.uploadValue = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.uploadValue = null;
    },
    onAttach(e) {
      if (this.fileList.length) {
        e.preventDefault();
      }
    },
    onBefore() {
      this.loading = true;
    },
    onSuccess(res) {
      this.loading = false;
      this.$emit("input", res);
    },
    onError() {
      this.loading = false;
      this.$emit("input", null);
      this.error = "Ошибка";
      this.$message({
        type: "error",
        message: "Ошибка при загрузке.",
      });
    },
  },
};
</script>
